import { render, staticRenderFns } from "./bloodFatFollowUp.vue?vue&type=template&id=38b41516&scoped=true"
import script from "./bloodFatFollowUp.vue?vue&type=script&lang=js"
export * from "./bloodFatFollowUp.vue?vue&type=script&lang=js"
import style0 from "./bloodFatFollowUp.vue?vue&type=style&index=0&id=38b41516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b41516",
  null
  
)

export default component.exports